'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDDWebTag = exports.getDDWebSha = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {object} windowParam - optional window object
 *
 * @return {string} Will return the current sha of your
 * application. This will return null when testing your
 * changes locally from dd-web but will return the correct
 * sha on staging and production.
 */
var getDDWebSha = function getDDWebSha() {
  var windowParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  return (0, _lodash2.default)(windowParam, '__dd.sha') || null;
};

/**
 * @param  {object} windowParam - optional window object
 *
 * @return {string} Will return the current tag of your 
 * application. This will return null when testing your 
 * changes locally from dd-web but will return the correct 
 * tag on staging and production.
 */
var getDDWebTag = function getDDWebTag() {
  var windowParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  return (0, _lodash2.default)(windowParam, '__dd.tag') || null;
};

exports.getDDWebSha = getDDWebSha;
exports.getDDWebTag = getDDWebTag;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZFdlYkhlbHBlcnMuanMiXSwibmFtZXMiOlsiZ2V0RERXZWJTaGEiLCJ3aW5kb3dQYXJhbSIsIndpbmRvdyIsImdldEREV2ViVGFnIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7OztBQUVBOzs7Ozs7OztBQVFBLElBQU1BLGNBQWMsU0FBZEEsV0FBYyxHQUEwQjtBQUFBLE1BQXpCQyxXQUF5Qix1RUFBWEMsTUFBVzs7QUFDNUMsU0FBTyxzQkFBSUQsV0FBSixFQUFpQixVQUFqQixLQUFnQyxJQUF2QztBQUNELENBRkQ7O0FBSUE7Ozs7Ozs7O0FBUUEsSUFBTUUsY0FBYyxTQUFkQSxXQUFjLEdBQTBCO0FBQUEsTUFBekJGLFdBQXlCLHVFQUFYQyxNQUFXOztBQUM1QyxTQUFPLHNCQUFJRCxXQUFKLEVBQWlCLFVBQWpCLEtBQWdDLElBQXZDO0FBQ0QsQ0FGRDs7UUFJU0QsVyxHQUFBQSxXO1FBQWFHLFcsR0FBQUEsVyIsImZpbGUiOiJkZFdlYkhlbHBlcnMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZ2V0IGZyb20gJ2xvZGFzaC5nZXQnXG5cbi8qKlxuICogQHBhcmFtIHtvYmplY3R9IHdpbmRvd1BhcmFtIC0gb3B0aW9uYWwgd2luZG93IG9iamVjdFxuICpcbiAqIEByZXR1cm4ge3N0cmluZ30gV2lsbCByZXR1cm4gdGhlIGN1cnJlbnQgc2hhIG9mIHlvdXJcbiAqIGFwcGxpY2F0aW9uLiBUaGlzIHdpbGwgcmV0dXJuIG51bGwgd2hlbiB0ZXN0aW5nIHlvdXJcbiAqIGNoYW5nZXMgbG9jYWxseSBmcm9tIGRkLXdlYiBidXQgd2lsbCByZXR1cm4gdGhlIGNvcnJlY3RcbiAqIHNoYSBvbiBzdGFnaW5nIGFuZCBwcm9kdWN0aW9uLlxuICovXG5jb25zdCBnZXRERFdlYlNoYSA9ICh3aW5kb3dQYXJhbSA9IHdpbmRvdykgPT4ge1xuICByZXR1cm4gZ2V0KHdpbmRvd1BhcmFtLCAnX19kZC5zaGEnKSB8fCBudWxsXG59XG5cbi8qKlxuICogQHBhcmFtICB7b2JqZWN0fSB3aW5kb3dQYXJhbSAtIG9wdGlvbmFsIHdpbmRvdyBvYmplY3RcbiAqXG4gKiBAcmV0dXJuIHtzdHJpbmd9IFdpbGwgcmV0dXJuIHRoZSBjdXJyZW50IHRhZyBvZiB5b3VyIFxuICogYXBwbGljYXRpb24uIFRoaXMgd2lsbCByZXR1cm4gbnVsbCB3aGVuIHRlc3RpbmcgeW91ciBcbiAqIGNoYW5nZXMgbG9jYWxseSBmcm9tIGRkLXdlYiBidXQgd2lsbCByZXR1cm4gdGhlIGNvcnJlY3QgXG4gKiB0YWcgb24gc3RhZ2luZyBhbmQgcHJvZHVjdGlvbi5cbiAqL1xuY29uc3QgZ2V0RERXZWJUYWcgPSAod2luZG93UGFyYW0gPSB3aW5kb3cpID0+IHtcbiAgcmV0dXJuIGdldCh3aW5kb3dQYXJhbSwgJ19fZGQudGFnJykgfHwgbnVsbFxufVxuXG5leHBvcnQgeyBnZXRERFdlYlNoYSwgZ2V0RERXZWJUYWcgfVxuIl19